/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DescriptiveBusinessObjectFormatUpdateRequest } from './descriptiveBusinessObjectFormatUpdateRequest';


export interface BusinessObjectDefinitionChangeEvent { 
    /**
     * Business friendly name
     */
    displayName?: string;
    /**
     * Description of the Business Object Definition
     */
    description?: string;
    descriptiveBusinessObjectFormat?: DescriptiveBusinessObjectFormatUpdateRequest;
    /**
     * The timestamp of when the business object definition update occured
     */
    eventTime: Date;
    /**
     * The User ID of the user who performed business object definition update
     */
    userId: string;
}
